/*
 * Copyright (c) 2026. Orion Analytics.
 */

import React, { useEffect, useState } from "react";

import NAV from "./nav";
import { fetchBlog } from "../api";
import PriceScroller from "../components/pricescroll";
import Carousel from "./carousel";

const CATEGORIES = [
    "Market Update",
    "Market Trends",
    "Investment Strategies",
    "AI & Finance",
    "Macroeconomics",
    "Policy & Regulation",
    "Education"
];

export default function Blog() {

    const [posts, setPosts] = useState([]);
    const [selectedPost, setSelectedPost] = useState(null);
    const [filteredCategory, setFilteredCategory] = useState(null);

    useEffect(() => {

        fetchBlog()
            .then((data) => {

                setPosts(data || []);

                if (data?.length > 0) {
                    setSelectedPost(data[0]);
                }

            })
            .catch((err) =>
                console.error("Blog Load Error", err)
            );

    }, []);

    const filteredPosts = filteredCategory
        ? posts.filter(
              (p) => p.category === filteredCategory
          )
        : posts;

    useEffect(() => {

        if (
            filteredPosts.length > 0 &&
            !filteredPosts.find(
                (x) => x.id === selectedPost?.id
            )
        ) {
            setSelectedPost(filteredPosts[0]);
        }

    }, [filteredCategory, posts]);

    return (

        <>
            {/*<PriceScroller />*/}

            <div
                className="
                    bg-slate-200
                    min-h-screen
                    py-10
                "
            >
                            <NAV activetag="blog"/>

                <div className="max-w-7xl mx-auto px-6">

                {/* HERO */}

                <section
                    className="
                        relative
                        -mt-24
                        pt-40
                        min-h-[450px]
                        w-screen
                        flex
                        items-center
                        justify-center
                        overflow-hidden
                        bg-gradient-to-r
                        from-slate-950
                        via-blue-950
                        to-slate-900
                    "
                    style={{
                        marginLeft: "calc(50% - 50vw)",
                    }}
                >
                    {/* Overlay */}

                    <div className="absolute inset-0 bg-black/40" />

                    {/* Content */}

                    <div
                        className="
                            relative
                            z-10
                            text-center
                            text-white
                            max-w-5xl
                            px-6
                            pt-24
                        "
                    >
                        <div
                            className="
                                inline-flex
                                items-center
                                gap-2
                                bg-blue-500/20
                                border
                                border-blue-400/30
                                px-4
                                py-2
                                rounded-full
                                text-sm
                                mb-6
                            "
                        >
                            📰 Orion Analytics Research
                        </div>

                        <h1
                            className="
                                text-5xl
                                md:text-6xl
                                font-extrabold
                                text-white
                                mb-6
                            "
                        >
                            Market Insights,
                            Research &
                            Investment Intelligence
                        </h1>

                        <p
                            className="
                                text-xl
                                text-slate-200
                                max-w-3xl
                                mx-auto
                            "
                        >
                            Research notes, market commentary,
                            quantitative investing ideas,
                            macroeconomic analysis and
                            educational content for investors.
                        </p>
                    </div>
                </section>

                    {/* CATEGORY BAR */}
                <div className="flex flex-wrap gap-4 mb-8 py-5">

    <button
        onClick={() => setFilteredCategory(null)}
        className={`
            inline-flex
            w-auto
            flex-none
            px-4
            py-2
            rounded-full
            text-sm
            font-medium
            transition

            ${
                !filteredCategory
                    ? "bg-blue-600 text-white"
                    : "bg-slate-500 border border-slate-200"
            }
        `}
    >
        All Articles
    </button>

    {CATEGORIES.map((cat) => (

        <button
            key={cat}
            onClick={() => setFilteredCategory(cat)}
            className={`
                inline-flex
                w-auto
                flex-none
                px-4
                py-2
                rounded-full
                text-sm
                font-medium
                transition

                ${
                    filteredCategory === cat
                        ? "bg-blue-600 text-white"
                        : "bg-slate-500 border border-slate-200"
                }
            `}
        >
            {cat}
        </button>

    ))}

</div>



                    {/* MAIN GRID */}

                    <div
                        className="
                            grid
                            grid-cols-12
                            gap-8
                        "
                    >

                        {/* SIDEBAR */}

                        <div
                            className="
                                col-span-12
                                lg:col-span-3
                            "
                        >

                            <div
                                className="
                                    bg-white
                                    rounded-3xl
                                    border
                                    border-slate-200
                                    shadow-sm
                                    overflow-hidden
                                "
                            >

                                <div
                                    className="
                                        px-5
                                        py-4
                                        border-b
                                    "
                                >

                                    <h3
                                        className="
                                            font-bold
                                            text-lg
                                        "
                                    >
                                        Latest Research
                                    </h3>

                                    <p
                                        className="
                                            text-sm
                                            text-slate-500
                                            mt-1
                                        "
                                    >
                                        {filteredPosts.length}
                                        {" "}
                                        articles
                                    </p>

                                </div>

                                <div
                                    className="
                                        max-h-[900px]
                                        overflow-y-auto
                                    "
                                >

                                    {filteredPosts.map((post) => (

                                        <button
                                            key={post.id}
                                            onClick={() =>
                                                setSelectedPost(post)
                                            }
                                            className={`
                                                w-full
                                                text-left
                                                px-5
                                                py-4
                                                border-b
                                                border-slate-100
                                                transition

                                                hover:bg-slate-50

                                                ${
                                                    selectedPost?.id === post.id
                                                        ? "bg-blue-50"
                                                        : ""
                                                }
                                            `}
                                        >

                                            <div
                                                className="
                                                    text-xs
                                                    uppercase
                                                    tracking-wide
                                                    text-red-950
                                                    mb-2
                                                "
                                            >
                                                {post.category}
                                            </div>

                                            <div
                                                className="
                                                    text-sm
                                                    font-semibold
                                                    text-slate-800
                                                    leading-relaxed
                                                "
                                            >
                                                {post.title}
                                            </div>

                                            <div
                                                className="
                                                    text-xs
                                                    text-slate-400
                                                    mt-2
                                                "
                                            >
                                                {post.date}
                                            </div>

                                        </button>

                                    ))}

                                </div>

                            </div>

                        </div>

                        {/* ARTICLE */}

                        <div
                            className="
                                col-span-12
                                lg:col-span-9
                            "
                        >

                            {selectedPost ? (

                                <div
                                    className="
                                        bg-slate-100
                                        rounded-3xl
                                        border
                                        border-slate-500
                                        shadow-sm
                                        p-10
                                    "
                                >

                                    <div
                                        className="
                                            inline-flex
                                            px-4
                                            py-2
                                            rounded-full
                                            bg-blue-100
                                            text-blue-700
                                            text-sm
                                            font-medium
                                            mb-5
                                        "
                                    >
                                        {selectedPost.category}
                                    </div>

                                    <h1
                                        className="
                                            text-4xl
                                            font-bold
                                            text-slate-900
                                            mb-4
                                        "
                                    >
                                        {selectedPost.title}
                                    </h1>

                                    <div
                                        className="
                                            text-sm
                                            text-slate-500
                                            mb-8
                                        "
                                    >
                                        {selectedPost.date}
                                    </div>

                                    <div
                                        className="
                                            prose
                                            prose-slate
                                            prose-lg
                                            max-w-none
                                        "
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                selectedPost.content
                                        }}
                                    />

                                    {selectedPost.media &&
                                        selectedPost.media.map(
                                            (
                                                media,
                                                idx
                                            ) => (

                                                media.file_type ===
                                                "image" ? (

                                                    <img
                                                        key={idx}
                                                        src={
                                                            media.file_url
                                                        }
                                                        alt=""
                                                        className="
                                                            rounded-2xl
                                                            shadow-lg
                                                            mt-8
                                                            w-full
                                                        "
                                                    />

                                                ) : (

                                                    <video
                                                        key={idx}
                                                        controls
                                                        className="
                                                            mt-8
                                                            rounded-2xl
                                                            w-full
                                                        "
                                                    >

                                                        <source
                                                            src={
                                                                media.file_url
                                                            }
                                                            type="video/mp4"
                                                        />

                                                    </video>

                                                )

                                            )
                                        )}

                                </div>

                            ) : (

                                <div
                                    className="
                                        bg-white
                                        rounded-3xl
                                        border
                                        border-slate-300
                                        p-20
                                        text-center
                                    "
                                >

                                    <h3
                                        className="
                                            text-2xl
                                            font-semibold
                                        "
                                    >
                                        Select an article
                                    </h3>

                                    <p
                                        className="
                                            text-slate-500
                                            mt-3
                                        "
                                    >
                                        Choose a research note
                                        from the left panel.
                                    </p>

                                </div>

                            )}

                        </div>

                    </div>

                </div>

            </div>
        </>
    );
}